import { memo, useRef, ElementRef, useCallback } from 'react';
import {
  useSharedValue,
  useAnimatedStyle,
  withSequence,
  withTiming,
  withRepeat,
  Easing,
  withDelay,
  runOnJS,
} from 'react-native-reanimated';
import { Box, Image, AnimationPlayer } from '@bonanza-social/moonlight';
import { StatusPromotionAnimationProps } from './StatusPromotionAnimation.types';
import promotionAnimations from './../../../assets/animations/promotion';

function StatusPromotionAnimation({
  playerStatus,
  onAnimationEnd,
}: StatusPromotionAnimationProps) {
  const playerRef = useRef<ElementRef<typeof AnimationPlayer>>(null);
  const scaleSV = useSharedValue(1);
  const rotateSV = useSharedValue(0);
  const animatedStyle = useAnimatedStyle(
    () => ({
      transform: [{ rotate: `${rotateSV.value}deg` }, { scale: scaleSV.value }],
    }),
    [],
  );

  const onSourceLoaded = useCallback(() => {
    const play = () => playerRef.current?.play?.();

    setTimeout(() => {
      playerRef.current?.reset?.();
    }, 0);

    scaleSV.value = withDelay(
      500,
      withSequence(
        withTiming(1.5, { duration: 500 }),
        withTiming(1.0, { duration: 500 }, () => {
          runOnJS(play)();
          onAnimationEnd();
        }),
        withTiming(2.0, { duration: 500 }),
        withDelay(500, withTiming(1.0, { duration: 500 })),
        withRepeat(withTiming(1.3, { duration: 800 }), -1, true),
      ),
    );
    rotateSV.value = withRepeat(
      withTiming(360, { duration: 5000, easing: Easing.linear }),
      -1,
    );
  }, [scaleSV, rotateSV, onAnimationEnd]);

  if (playerStatus === 'Member') {
    return;
  }

  return (
    <Box flex={1} paddingVertical="space-300" centerContent>
      <Box position="absolute" animatedStyle={animatedStyle}>
        <Image name="status.Glow" width={530} height={450} />
      </Box>
      <AnimationPlayer
        ref={playerRef}
        source={promotionAnimations[`to${playerStatus}`]}
        loop={playerStatus === 'Amethyst'}
        autoPlay={false}
        sizeX={200}
        sizeY={256}
        onSourceLoaded={onSourceLoaded}
      />
    </Box>
  );
}

export default memo(StatusPromotionAnimation);
